module.exports = __webpack_public_path__ + "static/ainoa-1641ebf8a64b1e40d5dba1b22b3797bd.png";